import {
  FETCH_MATERIAL_CATEGORIES_REQUEST,
  FETCH_MATERIAL_CATEGORIES_SUCCESS,
  FETCH_MATERIAL_CATEGORIES_FAILURE,
  SAVE_MATERIAL_CATEGORY_REQUEST,
  SAVE_MATERIAL_CATEGORY_SUCCESS,
  SAVE_MATERIAL_CATEGORY_FAILURE,
  DELETE_MATERIAL_CATEGORY_REQUEST,
  DELETE_MATERIAL_CATEGORY_SUCCESS,
  DELETE_MATERIAL_CATEGORY_FAILURE,
} from './types';

const INITIAL_STATE = {
  materialCatList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MATERIAL_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_MATERIAL_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        materialCatList: action.payload,
      };

    case FETCH_MATERIAL_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        materialCatList: [],
      };
    case SAVE_MATERIAL_CATEGORY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_MATERIAL_CATEGORY_SUCCESS:
      return {
        ...state,
      };

    case SAVE_MATERIAL_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_MATERIAL_CATEGORY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_MATERIAL_CATEGORY_SUCCESS:
      return {
        ...state,
      };

    case DELETE_MATERIAL_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
